import { Guid } from 'admin/lib/guid'
import { PROVIDER_DEFINITION_ID, MODULE_ID } from '@qflow/constants'
import type { EmailFormData, ConnectionFormData } from './connectionTypes'

export const DEFAULT_MOBILE_NAME = 'Qflow-mobile'
export const DEFAULT_EMAIL_NAME = 'Qflow-email'

export const EMAIL_MODE_NEW = 'new'
export const EMAIL_MODE_EXISTING = 'existing'
export type EmailMode = typeof EMAIL_MODE_NEW | typeof EMAIL_MODE_EXISTING

export const EMAIL_DOMAIN = '@qualisflow.com'
export const EMAIL_PREFIX_DELIVERIES = 'deliveries'
export const EMAIL_PREFIX_WASTE = 'waste'

export const PERMITTED_FILE_TYPES = '.pdf,.jpg,.jpeg,.png,.doc,.docx'
export const PERMITTED_SENDERS_PATTERN = '\\S+'

export const MAX_EMAIL_CONNECTIONS = 2

export const BLANK_EMAIL: EmailFormData = {
  email: '',
  emailIdentifier: '',
  moduleTagDefinitionId: '',
  permittedFileTypes: PERMITTED_FILE_TYPES,
  permittedSendersPattern: PERMITTED_SENDERS_PATTERN,
  isDeleted: false,
  feedId: Guid.Empty,
  instrumentId: Guid.Empty
}

export const BLANK_CONNECTION: ConnectionFormData = {
  name: DEFAULT_MOBILE_NAME,
  connPassword: '',
  connUsername: '',
  providerDefinitionId: PROVIDER_DEFINITION_ID.MOBILE_VALUE,
  isChanged: false,
  emails: [BLANK_EMAIL],
  sharedMailboxName: ''
}

export const PROVIDER_OPTIONS = [
  {
    label: 'Email Monitor',
    value: PROVIDER_DEFINITION_ID.EMAIL_VALUE
  },
  {
    label: 'Mobile Qflow V1.0',
    value: PROVIDER_DEFINITION_ID.MOBILE_VALUE
  }
]

export const MODULE_OPTIONS = [
  {
    label: 'Waste',
    value: MODULE_ID.WASTE
  },
  {
    label: 'Delivery',
    value: MODULE_ID.DELIVERY
  }
]
